import { notification } from "antd";
import SolicitacoesDeUpgradeService from "../../../services/http/services/Contratos/SolicitacoesDeUpgradeService";

export const getSolicitacoesNaoAtendidas = async () => {
    try {
        const response = await SolicitacoesDeUpgradeService.getQuantidadeNaoAtendida();
        return response.quantidade_nao_atendidas;
    } catch (error: any) {
        if (error?.message !== 'Requisicao cancelada!') {
            // notification.error({
            //     message: 'Erro',
            //     description: 'Não foi possível buscar as solicitações!',
            // });
        }
        return null;
    }
};
